<div class="ats" [class.is-dashboard]="isDashboard">

  <div class="page__loader" [class.overlay]="hasRequests">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <router-outlet></router-outlet>
</div>